//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  components: {},
  props: {
    web: {
      type: String,
      default: 'pc'
    }
  },
  data () {
    return {
      lang: this.$store.state.LanguageCode // 语言 例:zh-cn,en
    }
  },
  computed: {},
  watch: {},
  created () {

  },
  mounted () {

  },
  methods: {

  }
}
